<template>
  <v-card>
    <template>
      <v-card-title class="i-dialog-header-div">
        <span class="g-heading-m g-bold">{{ title }}</span>
      </v-card-title>

      <v-card-text class="text-center py-6">
        <template v-if="activeFamilyGroup">
          <span>
            {{ activeSpecialsQty + activePriceDropsQty + activeVolumePromoQty }}
            Active<template
              v-if="
                upcomingSpecialsQty +
                  upcomingPriceDropsQty +
                  upcomingVolumePromoQty >
                0
              "
            >
              &
              {{
                upcomingSpecialsQty +
                upcomingPriceDropsQty +
                upcomingVolumePromoQty
              }}
              Upcoming</template
            >
            Promotion(s) exist.
          </span>
          <br />
          <span>
            Do you want to delete Family Group & ALL (Active & Upcoming)
            promotions?
          </span>
        </template>

        <template v-else>
          <div v-if="activeOrUpcomingPromotions">
            <span>
              {{
                upcomingSpecialsQty +
                upcomingPriceDropsQty +
                upcomingVolumePromoQty
              }}
              Upcoming Promotions exist.
            </span>
            <span>
              Do you want to delete Family Group & ALL upcoming promotions?
            </span>
          </div>
          <div v-else>
            <span>Do you want to delete Family Group?</span>
          </div>
        </template>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions class="i-dialog-actions-div justify-center">
        <v-btn rounded text class="i-btn-text-black" @click="$emit('cancel')">
          <strong>Cancel</strong>
        </v-btn>

        <v-btn
          rounded
          class="i-btn-block-secondary"
          :loading="loading"
          @click="$emit('confirm')"
        >
          <strong>Delete</strong>
        </v-btn>
      </v-card-actions>
    </template>
  </v-card>
</template>

<script>
export default {
  data: () => ({
    dialog: false
  }),

  props: {
    familyGroup: {
      required: true,
      type: Object
    },
    loading: {
      default: false,
      type: Boolean
    },
    title: {
      default: 'Confirmation',
      type: String
    }
  },

  computed: {
    activeFamilyGroup() {
      if (!this.familyGroup) return false
      return this.familyGroup.status === 'LIVE'
    },

    activeOrUpcomingPromotions() {
      if (!this.familyGroup) return false
      return (
        this.familyGroup.activeOrFuturePromotions.length ||
        this.familyGroup.activeOrFuturePriceDrops.length ||
        this.familyGroup.activeOrFutureVolumePromotions.length
      )
    },

    activeSpecialsQty() {
      if (!this.familyGroup) return 0
      const qty = this.familyGroup.activeOrFuturePromotions.filter(
        (special) => special.status === 'ACTIVE'
      )
      return qty.length
    },

    upcomingSpecialsQty() {
      if (!this.familyGroup) return 0
      const qty = this.familyGroup.activeOrFuturePromotions.filter(
        (special) => special.status === 'UPCOMING'
      )
      return qty.length
    },

    activePriceDropsQty() {
      if (!this.familyGroup) return 0
      const qty = this.familyGroup.activeOrFuturePriceDrops.filter(
        (special) => special.status === 'ACTIVE'
      )
      return qty.length
    },

    upcomingPriceDropsQty() {
      if (!this.familyGroup) return 0
      const qty = this.familyGroup.activeOrFuturePriceDrops.filter(
        (special) => special.status === 'UPCOMING'
      )
      return qty.length
    },

    activeVolumePromoQty() {
      if (!this.familyGroup) return 0
      const qty = this.familyGroup.activeOrFutureVolumePromotions.filter(
        (special) => special.status === 'ACTIVE'
      )
      return qty.length
    },

    upcomingVolumePromoQty() {
      if (!this.familyGroup) return 0
      const qty = this.familyGroup.activeOrFutureVolumePromotions.filter(
        (special) => special.status === 'UPCOMING'
      )
      return qty.length
    }
  }
}
</script>
